"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DimensionList = exports.ModalTopButtonGroupContainer = void 0;
var aon_tws_common_ui_1 = require("@aon/aon-tws-common-ui");
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var contentConstants_1 = __importDefault(require("../../contentConstants"));
var models_1 = require("../../models");
var enum_1 = require("../../models/enum");
var utilities_1 = require("../../utilities");
var common_1 = require("../common");
var DimensionColumnHeader_1 = require("./DimensionColumnHeader");
var DimensionRow_1 = require("./DimensionRow");
var DimensionTable_1 = require("./DimensionTable");
var SelectContainer = styled_components_1.default.span.attrs({
    className: 'btn-group-container',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tfloat: left;\n\tmargin: 0 0 30px;\n"], ["\n\tfloat: left;\n\tmargin: 0 0 30px;\n"])));
SelectContainer.displayName = 'SelectContainer';
var PagingContainer = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tfloat: left;\n\twidth: 100%;\n"], ["\n\tfloat: left;\n\twidth: 100%;\n"])));
var NewCustomDimensionContainer = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tfloat: right;\n\tmargin: 0 0 30px;\n"], ["\n\tfloat: right;\n\tmargin: 0 0 30px;\n"])));
NewCustomDimensionContainer.displayName = 'NewCustomDimensionContainer';
exports.ModalTopButtonGroupContainer = styled_components_1.default.div.attrs({
    className: 'tws-button-group',
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t&.btn-group-container {\n\t\twidth: 100%;\n\t}\n"], ["\n\t&.btn-group-container {\n\t\twidth: 100%;\n\t}\n"])));
exports.ModalTopButtonGroupContainer.displayName = 'ModalTopButtonGroupContainer';
var DimensionList = /** @class */ (function (_super) {
    __extends(DimensionList, _super);
    function DimensionList(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            pageRange: { offset: 0, limit: 25 },
            selectedDimensionFilter: enum_1.DimensionFilterOption.AllDimensionsIndices.toString(),
        };
        _this.getFilteredDimensions = _this.getFilteredDimensions.bind(_this);
        _this.showOrphanDimension = _this.showOrphanDimension.bind(_this);
        return _this;
    }
    DimensionList.prototype.componentDidMount = function () {
        this.props.GetDimensions();
    };
    DimensionList.prototype.render = function () {
        var _this = this;
        var filteredDimensions = this.getFilteredDimensions(this.props.dimensions);
        var pageRange = __assign(__assign({}, this.state.pageRange), { total: filteredDimensions.length });
        return (React.createElement(React.Fragment, null, this.props.isDimensionsLoading ? (React.createElement(common_1.LoadingWrapper, null,
            React.createElement(aon_tws_common_ui_1.Loading, { height: '70px', width: '70px' }))) : (React.createElement(React.Fragment, null,
            React.createElement(exports.ModalTopButtonGroupContainer, null,
                this.props.filterOptions.length > 0 && (React.createElement(SelectContainer, null,
                    React.createElement(aon_tws_common_ui_1.Select, { size: 'md', selectSize: 'md', dropdownSize: 'md', selectedValue: this.state.selectedDimensionFilter, items: this.props.filterOptions, onApply: function (value) { return _this.setState({ selectedDimensionFilter: value }); } }))),
                React.createElement(NewCustomDimensionContainer, null,
                    React.createElement(aon_tws_common_ui_1.Button, { color: 'secondary', size: 'md', id: 'btn-new-custom-dimension', onClick: function () { return _this.props.ShowAddCustomDimension(); } }, contentConstants_1.default.DIMENSION_NEW_CUSTOM_DIMENSION))),
            React.createElement(PagingContainer, null,
                React.createElement(aon_tws_common_ui_1.PagingOptions, { pageRange: pageRange, updatePageRange: function (range) { return _this.setState({ pageRange: range }); } }),
                React.createElement(aon_tws_common_ui_1.Divider, { type: 'dashed' })),
            React.createElement(DimensionTable_1.DimensionTable, { responsive: true },
                React.createElement(DimensionColumnHeader_1.DimensionColumnHeader, { sortedBy: this.props.sortParams && this.props.sortParams[0].sortedBy, sortAsc: this.props.sortParams && this.props.sortParams[0].sortAsc === 'asc', handleSort: this.props.HandleSort, columns: utilities_1.ColumnHelper.GetColumnHeaders(this.props.dimensionColumns) }),
                React.createElement("tbody", null, new aon_tws_common_ui_1.PagingHelper().page(filteredDimensions, pageRange).map(function (dimension, index) {
                    return (React.createElement(DimensionRow_1.DimensionRow, __assign({}, _this.props, { GetDimension: function () { return _this.props.GetDimension(dimension.dimensionId); }, key: index, questions: dimension.surveyQuestions ? dimension.surveyQuestions : [], dimensionLanguages: dimension.translations.map(function (t) { return t.cultureCode; }), dimension: dimension })));
                }))),
            this.showOrphanDimension()))));
    };
    DimensionList.prototype.showOrphanDimension = function () {
        var _this = this;
        var orphanQuestions = this.props.orphanQuestions
            ? this.props.orphanQuestions
            : this.props.questions.filter(function (question) {
                return !question.isDemographic && (question.dimensionNames === undefined || question.dimensionNames.length === 0);
            });
        var demographicQuestions = this.props.demographicQuestions
            ? this.props.demographicQuestions
            : this.props.questions.filter(function (question) { return question.isDemographic; });
        return (React.createElement(React.Fragment, null,
            React.createElement(aon_tws_common_ui_1.Divider, { type: 'dashed' }),
            React.createElement(DimensionTable_1.DimensionTable, { responsive: true },
                React.createElement("tbody", null,
                    React.createElement(DimensionRow_1.DimensionRow, __assign({}, this.props, { GetDimension: function () { return _this.props.GetDimension(0); }, key: 'd', dimensionLanguages: [], questions: demographicQuestions, dimension: {
                            code: '',
                            dimensionType: enum_1.DimensionType.Dimension,
                            isScored: false,
                            name: contentConstants_1.default.DIMENSION_LIST_DEMOGRAPHIC_DIMENSION,
                            sourceType: models_1.SourceType.KincentricLibrary,
                            translations: [],
                            shouldDisableEdit: true,
                        } })),
                    React.createElement(DimensionRow_1.DimensionRow, __assign({}, this.props, { GetDimension: function () { return _this.props.GetDimension(0); }, key: 'o', dimensionLanguages: [], questions: orphanQuestions, dimension: {
                            code: '',
                            dimensionType: enum_1.DimensionType.Dimension,
                            isScored: false,
                            name: contentConstants_1.default.DIMENSION_LIST_NODIMENSION,
                            sourceType: models_1.SourceType.KincentricLibrary,
                            translations: [],
                            shouldDisableEdit: true,
                        } }))))));
    };
    DimensionList.prototype.getFilteredDimensions = function (dimensions) {
        var filteredDimensions = dimensions.filter(function (d) { return d.name !== contentConstants_1.default.DIMENSION_LIST_DEMOGRAPHIC_DIMENSION; });
        switch (this.state.selectedDimensionFilter) {
            case enum_1.DimensionFilterOption.KincentricDimensions:
                filteredDimensions = filteredDimensions.filter(function (dimension) {
                    return dimension.sourceType === models_1.SourceType.KincentricLibrary && dimension.dimensionType === enum_1.DimensionType.Dimension;
                });
                break;
            case enum_1.DimensionFilterOption.KincentricIndices:
                filteredDimensions = filteredDimensions.filter(function (dimension) {
                    return dimension.sourceType === models_1.SourceType.KincentricLibrary && dimension.dimensionType === enum_1.DimensionType.Index;
                });
                break;
            case enum_1.DimensionFilterOption.ClientDimensions:
                filteredDimensions = filteredDimensions.filter(function (dimension) {
                    return dimension.sourceType === models_1.SourceType.ClientLibrary && dimension.dimensionType === enum_1.DimensionType.Dimension;
                });
                break;
            case enum_1.DimensionFilterOption.ClientIndices:
                filteredDimensions = filteredDimensions.filter(function (dimension) {
                    return dimension.sourceType === models_1.SourceType.ClientLibrary && dimension.dimensionType === enum_1.DimensionType.Index;
                });
                break;
            default:
                break;
        }
        return filteredDimensions;
    };
    return DimensionList;
}(React.PureComponent));
exports.DimensionList = DimensionList;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
